import { useEffect, useState} from "react";
import './navbar.scss';
import { useContext } from "react";
import ScrollTopContext from "../../Contexts/ScrollTop";
import LanguageContext from "../../Contexts/Language";
import Button from "../Button/Button";
import { findNewHeight } from "../../Pages/Homepage/Homepage";
import {ReactComponent as Home} from '../../Assets/Svg/home.svg';
import {ReactComponent as AboutMe} from '../../Assets/Svg/aboutMe.svg';
import {ReactComponent as TechStack} from '../../Assets/Svg/techStack.svg';
import {ReactComponent as Experience} from '../../Assets/Svg/experience.svg';
import {ReactComponent as Projects} from '../../Assets/Svg/projects.svg';
import {ReactComponent as Contact} from '../../Assets/Svg/contact.svg';
const Navbar = () =>{
    const {setScrollTop} = useContext(ScrollTopContext);
    const {language} = useContext(LanguageContext);
    const [tick, setTick] = useState(0);
    const [homepageScrollTop,setHomepageScrollTop] = useState(document.getElementById("homepage-container")?.scrollTop || 0)
    const [currentHeight, setCurrentHeight] = useState(7453);

    useEffect(() =>{
        setHomepageScrollTop(document.getElementById("homepage-container")?.scrollTop || 0)
    },[tick])

    //force rendering
    useEffect(() => {
      const interval = setInterval(() => {
        setTick(t => t + 1);
      }, 333);
  
      return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        function reSize() {
            const newHeight = findNewHeight();
            setCurrentHeight(newHeight); 
        }
    
        reSize();
        window.addEventListener("resize", reSize);
        return () => {
        window.removeEventListener("resize", reSize);
        };
    }, [currentHeight]);

    const isActive = (min: number, max: number) => {
        return homepageScrollTop > (min / 7453) * currentHeight && homepageScrollTop < (max / 7453) * currentHeight ? "active-item" : "unset";
    };
      
    return(
        <div className="navbar">
            <div className="navbar-inner">
                <div className="navbar-box">
                    <Button className={`box-item ${isActive(-1, 100)}`} style={{ animationDelay: "1.2s" }} onClick={() => setScrollTop(-1)} ><span>{language.navbar.buttons[0]}</span><Home className="stroke"/></Button>
                    <Button className={`box-item ${isActive(99, 1400)}`} style={{ animationDelay: "1.3s" }} onClick={() => { setScrollTop(100)}} ><span>{language.navbar.buttons[1]}</span><AboutMe className="fill"/></Button>
                    <Button className={`box-item ${isActive(1399, 2700)}`} style={{ animationDelay: "1.4s" }} onClick={() => { setScrollTop(1900)}} ><span>{language.navbar.buttons[2]}</span><TechStack className="fill"/></Button>
                </div>
                <div className="navbar-box">
                    <Button className={`box-item ${isActive(2699, 4300)}`} style={{ animationDelay: "1.5s" }} onClick={() => { setScrollTop(3300)}} ><span>{language.navbar.buttons[3]}</span><Experience className="stroke"/></Button>
                    <Button className={`box-item ${isActive(4299, 5399)}`} style={{ animationDelay: "1.6s" }} onClick={() => { setScrollTop(4800)}} ><span>{language.navbar.buttons[4]}</span><Projects className="stroke"/></Button>
                    <Button className={`box-item ${isActive(5398,9999)}`} style={{ animationDelay: "1.7s" }} onClick={() => { setScrollTop(6100)}} ><span>{language.navbar.buttons[5]}</span><Contact className="fill"/></Button>
                </div>
            </div>
        </div>
    )
}
export default Navbar